import { paths } from "@rms-types/constants/paths";
import { lazy } from "react";

import { AppRoute } from "@/routes/types";

export const organizationRoutes: AppRoute[] = [
  {
    index: true,
    page: lazy(() => import("@/pages/organizations").then((module) => ({ default: module.Organizations }))),
    permissions: paths.app.organizations.permissions,
  },
  {
    path: paths.app.organizations.organizationDetails.path,
    page: lazy(() =>
      import("@/pages/organizations/organizationId").then((module) => ({ default: module.OrganizationDetailsPage }))
    ),
    permissions: paths.app.organizations.organizationDetails.permissions,
  },
];
